export default __webpack_public_path__ + "e4e1d8eb721308a025c1cc71b6867e41.wav";